import { forgotPassword } from './pages/forgotPassword';
import { geolocationDenied } from './pages/geolocationDenied';
import { login } from './pages/login';
import { validateToken } from './pages/validateToken';

export const es = {
  pages: {
    login,
    forgotPassword,
    geolocationDenied,
    validateToken,
  },
  components: {
    languageSwitch: {
      label: 'Cambiar idioma',
      pt: 'Portugués',
      en: 'Inglés',
      es: 'Español',
    },
    servicesSelection: {
      title: 'Seleccionar servicios',
      selectAtLeastOne: 'Seleccione al menos un servicio',
      next: 'Siguiente',
    },
    additionalFields: {
      title: 'Campos Adicionales',
      back: 'volver',
      zipLabel: 'Código postal',
      phoneLabel: 'Teléfono',
      emailLabel: 'E-mail',
      next: 'Siguiente',
      zipRequired: '¡El código postal es obligatorio!',
      phoneRequired: '¡El teléfono es obligatorio!',
      emailRequired: '¡El e-mail es obligatorio!',
    },
    bodyStep: {
      identificationBy: 'Identificación por {{validation}}',
      companyLabel: 'Empresa:',
      userLabel: 'Usuario:',
      signOut: 'Salir',
      versionLabel: 'Versión:',
      apiVersionLabel: 'Versión de la API:',
    },
    camera: {
      title: 'Foto',
      back: 'volver',
      clear: 'LIMPIAR',
      next: 'SIGUIENTE',
      uploadImage: 'SUBIR IMAGEN',
      camera: 'CÁMARA',
      takePhoto: 'TOMAR FOTO',
    },
    choose: {
      title: 'Seleccionar método de análisis',
      back: 'volver',
      cnhOption: 'Análisis por foto de DNI/Pasaporte',
      faceOption: 'Análisis por foto de rostro',
    },
    identification: {
      title: 'Datos Personales',
      back: 'volver',
      nameLabel: 'Nombre completo',
      birthLabel: 'Fecha de nacimiento',
      documentTypeLabel: 'Tipo de documento',
      documentNumberLabel: 'Número de documento',
      next: 'Siguiente',
      nameRequired: '¡El nombre es obligatorio!',
      birthRequired: '¡La fecha de nacimiento es obligatoria!',
      documentInvalid: 'Documento inválido',
    },
    instructions: {
      title: 'Instrucciones',
      back: 'volver',
      next: 'Siguiente',
      selfie: {
        faceVisible: 'Tómate una selfie con el rostro de frente y visible',
        goodLighting: 'Busca una buena iluminación',
        removeAccessories: 'Quita accesorios como gafas y sombrero',
        avoidRotation: 'Evita rotar la cámara del dispositivo',
      },
      document: {
        flatSurface: 'Apoya el documento sobre una superficie plana',
        goodLighting: 'Busca una buena iluminación',
        adjustFocus: 'Ajusta el enfoque para garantizar la calidad',
        avoidRotation: 'Evita rotar la cámara del dispositivo',
      },
    },
    result: {
      title: 'Resultado',
      fullName: 'Nombre completo',
      document: 'Documento',
      status: {
        recommended: 'SIN OBSERVACIONES',
        notRecommended: 'CON OBSERVACIONES',
        failed: 'FALLO',
      },
      buttons: {
        returnToPlatform: 'Volver a la plataforma SGRLOC',
        takeAnotherPhoto: 'Tomar otra foto',
        backToStart: 'Volver al inicio',
      },
    },
    optIn: {
      title: 'Términos de Uso',
      checkboxText: 'He leído y acepto estos términos y condiciones',
      buttons: {
        accept: 'Aceptar',
        refuse: 'Rechazar',
      },
    },
    faceTecCamera: {
      back: 'volver',
      titleCaptured: 'Foto capturada',
      titleDefault: 'Foto',
      buttons: {
        clear: 'LIMPIAR',
        next: 'SIGUIENTE',
        startCamera: 'INICIAR CÁMARA',
      },
      loadingCapture: 'Cargando la captura',
      capturedAlt: 'Foto capturada',
    },
    loading: {
      alt: 'Cargando...',
    },
    dropzone: {
      documentAlt: 'Imagen del documento',
      placeholder: 'Seleccione su documento',
      fileTooLarge: 'El tamaño máximo de la imagen debe ser de 1Mb',
    },
    logos: {
      sgrLoc: 'Logo de SGRLoc',
      swint: 'Logo de Odeen',
    },
  },
};

export default es;
